import { render } from "./AdminTableDeleteUserButton.vue?vue&type=template&id=2f122bd6&ts=true"
import script from "./AdminTableDeleteUserButton.vue?vue&type=script&lang=ts"
export * from "./AdminTableDeleteUserButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-ce2d8e187f/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__